export const selectFactoryCases = (state) => state.factoryCases.factoryCases;
export const selectFactoryCasesLoading = (state) => state.factoryCases.loading;
export const selectFactoryCasesError = (state) => state.factoryCases.error;
export const selectActiveCommentFormId = (state)=> state.factoryCases.tableActiveCommentForm;
export const selectExpandedRows = state => state.factoryCases.masterDetailExpandedRows;
export const selectFactoryCasesTableSortOptions = (state)=> state.factoryCases.orderBy;